import processSpecificCampaignNoteChange from '../processes/processSpecificCampaignNoteChange'
import processCharacteristicChange from '../processes/processCharacteristicChange'
import processSpecificCountChange from '../processes/processSpecificCountChange'
import processSpecificSkillChange from '../processes/processSpecificSkillChange'
import processSpecificSpellChange from '../processes/processSpecificSpellChange'
import processSpecificItemChange from '../processes/processSpecificItemChange'
import processSpecificRuneChange from '../processes/processSpecificRuneChange'
import processProfileIntegrity from '../processes/processProfileIntegrity'

import isCharacteristicPrefix from '../helpers/isCharacteristicPrefix'
import trackProfileChanges from '../helpers/trackProfileChanges'
import getPropPrefix from '../helpers/getPropPrefix'
import isEmpty from '../helpers/isEmpty'
//--------------------------
// process character change
//--------------------------
export default function processChange({
  original = {},
  changes = {},
  character,
  change,
  changesQueue = [],
  isNewCharacterLoad,
} = {}) {
  //
  console.log('-------------------------------------------')
  console.log('IN processChange')
  //----------
  // get args
  //----------
  const original_profile = original.profile ?? []
  const original_chars = original.chars ?? []
  const original_skills = original.skills ?? []
  const original_runes = original.runes ?? []
  const original_items = original.items ?? []
  const original_counts = original.counts ?? []
  const original_spells = original.spells ?? []
  const original_campaign_notes = original.campaign_notes ?? []

  let these_changes = {
    profile: changes.profile ?? [],
    chars: changes.chars ?? [],
    skills: changes.skills ?? [],
    runes: changes.runes ?? [],
    items: changes.items ?? [],
    counts: changes.counts ?? [],
    spells: changes.spells ?? [],
    campaign_notes: changes.campaign_notes ?? [],
  }
  let this_character = character ?? null
  let this_isNewCharacterLoad = isNewCharacterLoad ?? false
  //----------
  // declares
  //----------
  let calc_container_contents = null
  let existing_casting_skill = null
  let new_casting_skill_rune = null
  let remove_equipped_armour = null
  let add_equipped_armour = null
  let apply_rune_adjs_rune = null
  let update_rune_item_adjs = {}
  let integrityChanges = false
  let new_adjs = []
  let clear_item = null
  //-------------------------
  // initialize change queue
  //-------------------------
  let changeQueue = []
  if (Array.isArray(changesQueue) && changesQueue.length > 0) {
    changeQueue.push(...changesQueue.filter((queuedChange) => !isEmpty(queuedChange)))
  } else if (!isEmpty(change)) {
    changeQueue.push(change)
  }
  //===================================
  // process change queue until empty
  //-----------------------------------
  do {
    //----------------------------
    // get next change to process
    //----------------------------
    let this_change = changeQueue.shift()
    //-----------------------------------
    // changes recorded via handleUpdate
    //-----------------------------------
    console.log('**********************************************')
    console.log('**********************************************')
    console.log('THIS CHANGE = ', this_change)
    console.log('**********************************************')
    console.log('**********************************************')
    //-----------------
    // get change type
    //-----------------
    let changeType = this_change.type
    console.log('CHANGE EXISTS changeType = ' + changeType)
    //===============================================
    // A. change type: PROFILE
    //-------------------------
    if (changeType == 'profile' || changeType == 'ability') {
      console.log('IS PROFILE/ABILITY CHANGE!!')
      //-----------------------
      // track profile changes
      //-----------------------
      let field = this_change.key
      these_changes.profile = trackProfileChanges({
        field,
        character: this_character,
        original_profile,
        changed_profile: these_changes.profile,
      })
      //--------------------------------------------------------------------
      // manage character profile integrity (i.e. between drop-down values)
      //--------------------------------------------------------------------
      let res = processProfileIntegrity({
        change: this_change,
        character: this_character,
      })
      if (res) {
        this_character = res.character
        if (Array.isArray(res.ability_adjs)) {
          this_character.ability_adjs = res.ability_adjs
        }
        if (res.new_adjs && res.new_adjs.length > 0) {
          console.log('NEW ADJS FROM processProfileIntegrity = ', res.new_adjs)
          new_adjs.push(...res.new_adjs)
        }
        // console.log('!!!! RESULT FROM processProfileIntegrity = ', res)
        //----------------------------------
        // add any profile changes to queue
        //----------------------------------
        if (res.profile_changes && res.profile_changes.length > 0) {
          console.log('Adding profile changes to queue:', res.profile_changes)
          changeQueue.push(...res.profile_changes)
        }
        //-----------------------------------------
        // add any characteristic changes to queue
        //-----------------------------------------
        if (res.characteristic_changes && res.characteristic_changes.length > 0) {
          console.log('Adding characteristic changes to queue:', res.characteristic_changes)
          changeQueue.push(...res.characteristic_changes)
        }
        //----------------------------------
        // add any ability changes to queue
        //----------------------------------
        if (res.ability_changes && res.ability_changes.length > 0) {
          console.log('Adding ability changes to queue:', res.ability_changes)
          changeQueue.push(...res.ability_changes)
        }
      }
      //===============================================
      // B. change type: CHARACTERISTIC
      //--------------------------------
    } else if (changeType == 'characteristic') {
      //-----------------
      // get char prefix
      //-----------------
      let pfx = getPropPrefix(this_change.key)
      console.log('pfx = ' + pfx)
      let isChar = isCharacteristicPrefix(pfx)
      //------------------------------
      // check prefix is a valid char
      //------------------------------
      if (isChar) {
        console.log('IS CHAR!!')
        //----------------------------------
        // go manage characteristic changes
        //----------------------------------
        const result = processCharacteristicChange({
          pfx,
          original_chars,
          changed_chars: these_changes.chars,
          isNewCharacterLoad: this_isNewCharacterLoad,
          character: this_character,
        })
        this_character = result.character
        these_changes.chars = result.changed_chars
      }
      //===============================================
      // C. change type: SKILLS
      //------------------------
    } else if (changeType == 'skills') {
      //----------------------
      // manage skill changes
      //----------------------
      these_changes.skills = processSpecificSkillChange({
        skill: this_change.object, // no change arg as change fields fixed and passed in skill object
        original_skills,
        changed_skills: these_changes.skills,
        character: this_character,
      })
      //===============================================
      // D. change type: ITEMS
      //-----------------------
    } else if (changeType == 'items') {
      //----------------------
      // manage item changes
      //----------------------
      const res = processSpecificItemChange({
        change: this_change, // separate change arg as change fields variable
        item: this_change.object,
        original_items,
        changed_items: these_changes.items,
        character: this_character,
      })
      //------------
      // got result
      //------------
      if (res) {
        these_changes.items = res.changed_items
        calc_container_contents = res.calc_container_contents ?? calc_container_contents
        clear_item = res.clear_item ?? clear_item
        remove_equipped_armour = res.remove_equipped_armour ?? remove_equipped_armour
        add_equipped_armour = res.add_equipped_armour ?? add_equipped_armour
      } else {
        console.error(
          'ERROR: processing specific item change for item = ' + this_change.object.name,
        )
      }
      //===============================================
      // F. change type: RUNES
      //------------------------
    } else if (changeType == 'runes') {
      //-----------------------
      // go manage rune change
      //-----------------------
      const res = processSpecificRuneChange({
        change: this_change,
        rune: this_change.object,
        original_runes,
        changed_runes: these_changes.runes,
        character: this_character,
      })
      //------------
      // got result
      //------------
      if (res) {
        this_character = res.character
        these_changes.runes = res.changed_runes
        existing_casting_skill = res.existing_casting_skill
        new_casting_skill_rune = res.new_casting_skill_rune
        apply_rune_adjs_rune = res.apply_rune_adjs_rune
        update_rune_item_adjs = res.update_rune_item_adjs
        //---------------------------------------------------
        // update existing casting skill in character skills
        //---------------------------------------------------
        console.log('existing_casting_skill from specific rune change = ', existing_casting_skill)
        if (existing_casting_skill) {
          const skillIndex = this_character.skills.findIndex(
            (s) => s.id === existing_casting_skill.id,
          )
          if (skillIndex !== -1) {
            this_character.skills.splice(skillIndex, 1, existing_casting_skill)
          } else {
            // console.error('ERROR: Casting skill not found in character skills for rune = ' + this_change.object.name)
            console.log(
              'Must be adding new casting skill to character skills for rune = ' +
                this_change.object.name,
            )
          }
        }
      } else {
        console.error(
          'ERROR: processing specific rune change for rune = ' + this_change.object.name,
        )
      }
      console.log('KKKKK these_changes.runes = ', these_changes.runes)
      //===============================================
      // G. change type: SPELLS
      //------------------------
    } else if (changeType == 'spells') {
      //----------------------
      // manage spell changes
      //----------------------
      these_changes.spells = processSpecificSpellChange({
        change: this_change, // separate change arg as change fields variable
        spell: this_change.object,
        original_spells,
        changed_spells: these_changes.spells,
        character: this_character,
      })
      //------------------
      // catch no results
      //------------------
      if (!these_changes.spells) {
        console.error(
          'ERROR: processing specific spell change for spell = ' + this_change.object.name,
        )
      }
      //===============================================
      // H. change type: COUNTS
      //------------------------
    } else if (changeType == 'counts') {
      //----------------------
      // manage count changes
      //----------------------
      const res = processSpecificCountChange({
        change: this_change, // separate change arg as change fields variable
        count: this_change.object,
        original_counts,
        changed_counts: these_changes.counts,
        character: this_character,
      })
      //------------
      // got result
      //------------
      if (res) {
        these_changes.counts = res
      } else {
        console.error(
          'ERROR: processing specific count change for count = ' + this_change.object.name,
        )
      }
      //===============================================
      // I. change type: CAMPAIGN NOTES
      //--------------------------------
    } else if (changeType == 'campaign_notes') {
      //------------------------------
      // manage campaign note changes
      //------------------------------
      const res = processSpecificCampaignNoteChange({
        change: this_change, // separate change arg as change fields variable
        campaign_note: this_change.object,
        original_campaign_notes,
        changed_campaign_notes: these_changes.campaign_notes,
        character: this_character,
      })
      //------------
      // got result
      //------------
      if (res) {
        these_changes.campaign_notes = res
      } else {
        console.error(
          'ERROR: processing specific campaign note change for campaign note = ' + this_change.object.updated_at,
        )
      }
    }
    //----------------------------------
    // check changes remaining in queue
    //----------------------------------
    console.log('remaining changes in queue:', changeQueue.length)
  } while (changeQueue.length > 0)
  //===============================================
  // returns
  //---------
  return {
    these_changes,
    this_character,
    new_adjs,
    integrityChanges,
    new_casting_skill_rune,
    apply_rune_adjs_rune,
    update_rune_item_adjs,
    calc_container_contents,
    clear_item,
    remove_equipped_armour,
    add_equipped_armour,
  }
}
